module.exports = __webpack_public_path__ + "static/media/banner.a036095f.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/compliance/banner.png
// module id = 648
// module chunks = 0